export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_3-22dcb4ce05c623aac6644d9b3e8d84f6.svg";